/************************************************************
 Dental Medicine Medical Act Namespace
 ************************************************************/

window.dentalMedicineMedicalActNS = {
    _row: null,
    _action: null,
    _callback: null,

    executeAction: function (action, row, callback) {
        var wfId = parseInt(action.wf_id);
        var actionId = parseInt(action.wf_action_id);
        var task_id = parseInt(row.task_id);

        dentalMedicineMedicalActNS._action = action;
        dentalMedicineMedicalActNS._row = row;
        dentalMedicineMedicalActNS._callback = callback;


        if (actionId == globalConstants.ACTION_MEDICAL_ACT_DENTAL_MEDICINE_CANCEL) {
            //dentalMedicineMedicalActNS.executeMedicalActAction(action, row, function(){Hades.reloadScreen()});
            workflow.openGenericReasonModal();
        } else if (actionId == globalConstants.ACTION_MEDICAL_ACT_DENTAL_MEDICINE_EXECUTE) {
            dentalMedicineMedicalActNS.executeMedicalActAction(action, row, callback);
        }


    },

    executeMedicalActAction: function(action, row, callback) {
        debug.log('executeAction:', action);
        this._action = action;
        this._callback = callback;
        this._row = row;

        var params = {
            task_id:action.task_id,
            wf_id:action.wf_id,
            wf_status_id:action.from_state_id,
            wf_action_id:action.wf_action_id};

        $.getJSON('/dental_medicine/dental_consult/execute_action', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success) {
                    callback(true, action, row);

                } else {
                    //Hades.showError(Hades.workflowErrorMsg(), data.error, xhr, status, data.error);
                    bootbox.alert(data.error);

                    Hades.hideLoading();

                    callback(false, action, row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();

                callback(false, action, row);
            });
    },

    executeGenericAction: function (action, row, callback) {
        workflow.executeGenericAction(action, callback, row);
    },

    // Open Reason
    openReason:function (callback) {
        var params = {
            item_id:dentalMedicineMedicalActNS._row.item_id,
            wf_id:dentalMedicineMedicalActNS._action.wf_id,
            wf_status_id:dentalMedicineMedicalActNS._action.to_state_id,
            wf_action_id:dentalMedicineMedicalActNS._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                dentalMedicineMedicalActNS._callback(false, medicalAct._action, medicalAct._row);
            });
    },

    cancelReasonModalHandler: function(event, data) {

        $.fancybox.close(true);

        var params = {
            task_id: workflow._action.task_id,
            wf_id: workflow._action.wf_id,
            wf_status_id: workflow._action.from_state_id,
            wf_action_id: workflow._action.wf_action_id,

            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour
        };

        debug.log('executeGenericActionWithReason', params);

        $.getJSON('/dental_medicine/dental_consult/execute_action', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    workflow._callback(false, workflow._action, workflow._row);
                } else {
                    workflow._callback(true, workflow._action, workflow._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                workflow._callback(false, workflow._action, workflow._row);
            });
    },

    executeGenericActionWithReason: function (specific_callback) {
        workflow.openGenericReasonModal(specific_callback);
    }




};